import React from "react";
import { Route, Redirect } from "react-router-dom";

export default ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
       cProps.session !== null && cProps.isAdmin
        ? <C {...props} {...cProps} />
        : ( cProps.session === null )
        ? <Redirect
            to={`/login?redirect=${props.location.pathname}${props.location
              .search}`}
          />
        : <Redirect
            to={`/?redirect=${props.location.pathname}${props.location.search}`}
          />
      }
  />;